import React from 'react'
import { Modal } from 'react-bootstrap'
import styles from './InformationModal.module.scss'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'
import Button from 'design-system/button'
import { ButtonSizes, ButtonVariant } from 'design-system/button/src/Button'

interface IInformationModal {
  show: boolean
  title?: string
  text: any
  acceptButtonText?: string
  onAccept: any
  onClose?(): void
  twoButtons?: boolean
}

const InformationModal: React.FC<IInformationModal> = ({
  show,
  title = '',
  text,
  acceptButtonText = '',
  onAccept,
  onClose,
  twoButtons = true,
}) => {
  const { t } = useTranslation()

  const handleOnAccept = () => {
    onAccept()
  }

  return (
    <Modal
      show={show}
      size="lg"
      centered
      className={styles.modalContainer}
      onHide={onClose}
    >
      <Modal.Header
        translate="yes"
        closeButton
        className={`${styles.modalHeader} d-flex align-items-center`}
      >
        <FontAwesomeIcon icon={faExclamationTriangle} />
        <h1 className="title">{title || t('components.modal.titles.info')}</h1>
      </Modal.Header>
      <Modal.Body className="px-4 py-4">
        <div className={styles.text}>{text}</div>
      </Modal.Body>
      <div className="px-4 d-flex justify-content-center">
        <div className="dropdown-divider m-0 w-100 " />
      </div>
      <Modal.Footer className="border-0">
        {twoButtons && (
          <Button
            size={ButtonSizes.Small}
            variant={ButtonVariant.Secondary}
            className="my-0"
            onClick={onClose}
          >
            {t('components.modal.buttons.cancel')}
          </Button>
        )}
        <Button
          size={ButtonSizes.Small}
          variant={ButtonVariant.Primary}
          className="my-0"
          onClick={handleOnAccept}
        >
          {acceptButtonText || t('components.modal.buttons.accept')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default InformationModal
